<template>
  <div class="sendRepair-detail">
    <content-block style="padding-bottom: 0;">
      <div class="detail-box">
        <img :src="require('@/assets/imgs/ic_document_2.svg')" class="detail-pic" />
        <div class="detail-title">
          <b>
            寄修单号：{{ detail.code || '--' }}
            <span :class="[ 'common-status', `status-${detail.status}`]">
              {{ detail.statusMsg }}
            </span>
            <el-tooltip
                v-if="detail.status === 8"
                effect="dark"
                :content="`关闭原因：${detail.closeReason}`"
                placement="top-start"
              >
                <i class="el-icon-warning-outline" style="color: red;"></i>
              </el-tooltip>
          </b>
          <span>{{ `${detail.tenantName}_${detail.code}` || '--' }}</span>
        </div>
        <el-image v-if="detail.checkStatus" class="check-img" fit="scale-down" :src="getCheckStatus()"  />
      </div>
      <el-tabs v-model="activeName">
        <el-tab-pane label="寄修信息" name="sendRepair"/>
        <el-tab-pane label="日志动态" name="logs"/>
      </el-tabs>
    </content-block>
    <content-block style="padding: 0;">
      <SendRepairDetail v-if="activeName === 'sendRepair'" :info="detail" />
      <div v-if="activeName === 'logs'">
        <logs :id="id" :tenantId="detail.tenantId" />
      </div>
    </content-block>
  </div>
</template>
<script>
import { sendRepairDetail } from '@/api/RFQ';
import SendRepairDetail from './component/SendRepairDetail.vue';
import logs from '../components/logs.vue';
export default {
  components: {
    SendRepairDetail,
    logs,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      disabled: false,
      emptyIcon: require('@/assets/imgs/default.svg'), // eslint-disable-line
      activeName: 'sendRepair',
      detail: {},
    };
  },
  watch: {
    id: {
      handler (v) {
        v && this.refresh();
      },
      immediate: true,
    },
  },
  methods: {
    getStatusColor (v) {
      const blue = ['PART_TASK_ORDER', 'PART_QUOTE_PRICE'];
      const green = ['ALL_QUOTE_PRICE', 'ALL_TASK_ORDER'];
      const orange = ['NOT_TASK_ORDER', 'NOT_QUOTE_PRICE', 'NOT'];
      const grey = ['CLOSED'];
      if (blue.includes(v)) return 'blue';
      if (green.includes(v)) return 'green';
      if (orange.includes(v)) return 'orange';
      if (grey.includes(v)) return 'grey';
      return 'grey';
    },
    getCheckStatus () {
      if (this.detail.checkStatus === 1) {
        return require('@/assets/imgs/ic_checkpass.png'); // eslint-disable-line
      }
      if (this.detail.checkStatus === 2) {
        return require('@/assets/imgs/ic_checkFailed.png'); // eslint-disable-line
      }

      return null;
    },
    async getDetail () {
      const { body } = await sendRepairDetail({
        id: this.id,
        findLogisticsTrackFlag: true,
        findRecordFlag: true,
      });
      this.detail = { ...this.detail, ...body };
    },
    refresh () {
      this.getDetail();
    },
  },
};
</script>
<style lang="scss" scoped>
.sendRepair-detail {
  /deep/.el-tabs__header {
    margin-bottom: 0;
    padding-left: 15px;
    padding-right: 15px;
  }
  .detail-box {
    position: relative;
    display: flex;
    align-items: center;
    padding: 8px;
    .detail-pic {
      width: 40px;
      height: 40px;
      margin-right: 8px;
    }
    .detail-title {
      font-size: 14px;
      color: #303133;
      display: inline-flex;
      flex-direction: column;
      margin-right: 10px;

      .common-status {
        padding: 4px;
      }

      .status-2, .status-3 {
            background-color: #FEFAE0;
            color: #FAB007;

            &:before {
              color: #FAB007;
            }
          }

          .status-4, .status-5, .status-1 {
            background: #E2F3FE;;
            color: #237FFA;

            &:before {
              color: #237FFA;
            }
          }

          .status-8 {
            background-color: #F2F4F7;
            color: #1F2733;

            &:before {
              color: #1F2733;
            }
          }
    }

    .check-img {
      position: absolute;
      width: 56px;
      height: 56px;
      right: 100px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
}
</style>
